import { type ComponentPropsWithoutRef } from 'react';

import { cn } from '@/utils/cn';

export type StickyActionBarProps = ComponentPropsWithoutRef<'div'>;

/**
 * Bottom-sticky container for the primary CTA.
 *
 * `sticky` rather than `fixed`, so the bar participates in the scroll container and cannot cover
 * content the player still needs to read — the difference shows up immediately with the mobile
 * keyboard open, which is E2E journey 7.
 *
 * The `pb-[max(1rem,env(safe-area-inset-bottom))]` is required on iPhone home-indicator devices and
 * is the reason `viewport-fit=cover` is in the viewport meta. Without it the CTA sits under the
 * indicator and is genuinely hard to tap.
 */
export function StickyActionBar({ className, children, ...rest }: StickyActionBarProps) {
  return (
    <div
      className={cn(
        'bg-background border-border sticky bottom-0 z-10 -mx-4 border-t px-4 sm:-mx-5 sm:px-5',
        'pt-3 pb-[max(0.75rem,env(safe-area-inset-bottom))]',
        className,
      )}
      {...rest}
    >
      {children}
    </div>
  );
}
